export const OPEN_LOGIN_MODAL = "OPEN_LOGIN_MODAL";
export const OPEN_REGISTER_MODAL = "OPEN_REGISTER_MODAL";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_IS_LOGGED_IN = "SET_IS_LOGGED_IN";
export const SET_ARTICLE = "SET_ARTICLE";
export const SET_COMMENT_SECTION = "SET_COMMENT_SECTION";